/** Proveedores de despacho — operación Chía. envia.com = default holding (Saludable). */
export const DEFAULT_SHIPPING_CARRIER = 'envia';

export const SHIPPING_CARRIERS = [
  {
    value: 'envia',
    label: 'envia.com (default holding)',
    trackingRequired: true,
    trackingPlaceholder: 'N° guía envia.com'
  },
  {
    value: 'javiland_local',
    label: 'Javiland — entrega propia (≤5 km)',
    trackingRequired: false,
    trackingPlaceholder: 'Opcional (ej. LOCAL-JAV-…)'
  },
  {
    value: 'mee',
    label: 'Mis Envíos Express (Chía)',
    trackingRequired: true,
    trackingPlaceholder: 'N° guía MEE / Coordinadora / Deprisa'
  },
  {
    value: 'envia_legacy',
    label: 'Envia.com (legacy checkout)',
    trackingRequired: true,
    trackingPlaceholder: 'N° guía Envia'
  }
];

export function carrierLabel(value) {
  const c = SHIPPING_CARRIERS.find((x) => x.value === value);
  return c ? c.label : value || '—';
}

export function carrierTrackingRequired(value) {
  const c = SHIPPING_CARRIERS.find((x) => x.value === value);
  return c ? c.trackingRequired : true;
}
